module.exports = __webpack_public_path__ + "img/1536316161.33a05e10.jpg";